"use strict";

angular.module("customer")
.directive("communityCarouselItem", function() {
    return {
        restrict: "E",
        templateUrl: require("./community-carousel-item.directive.html"),
        controller: CommunityCarouseItemController,
        controllerAs: "communityCarouseItemCtrl"
    };
});

function CommunityCarouseItemController($scope, CommunityCarouselService, REFRESH_HOME_VENDOR_LISTING_MESSAGE_NAME) {
    var isFetching = false;

    this.onClick = function(instance) {
        if ($scope.slick.shouldClick) {
            if (!isFetching && instance.id !== $scope.selectedFilter.id) {
                isFetching = true;
                CommunityCarouselService.updateSelectedCommunity(instance.filter, instance.id)
                .then(function onSuccess() {
                    $scope.$emit("communitySelected", instance);
                    $scope.$emit(REFRESH_HOME_VENDOR_LISTING_MESSAGE_NAME);
                    isFetching = false;
                });
            }
        }
    };
}



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/community-carousel/community-carousel-item.directive.js
// module id = 841
// module chunks = 0